import { Colors } from '../../consts/Colors.js';

export default class QcmCheckA2 extends Phaser.GameObjects.Container {
    constructor(scene, x,y, repData, qcm) {
        super(scene, x, y, []);
        scene.add.existing(this);
        this.scene = scene;
        this.repData = repData;
        this.isSelected = false;
        this.qcm = qcm;
        this.isRight = repData.isTrue;


        this.backRect = this.scene.add.rexRoundRectangle(0, 0, 30, 30, 7, Colors.Elmt.MidOrange,0).setOrigin(0.5);
        this.backRect.setStrokeStyle(4, Colors.Elmt.Black);
        this.add(this.backRect);

        this.internalRect = this.scene.add.rexRoundRectangle(0, 0, 21, 21, 7, Colors.Elmt.MainBlue).setOrigin(0.5).setAlpha(0);
        this.add(this.internalRect);

        this.repText = this.scene.createTextElement(40, -20, this.repData);
        this.add(this.repText)
        this.clickSound = this.scene.sound.add('click', { volume: 0.4 });


        // this.backRect.setInteractive({ useHandCursor: true })
       
        this.backRect.on('pointerdown', () => {
            this.clickSound.play();
            if (!this.isSelected) {
                this.isSelected = true;
                this.qcm.allReps.filter(r => r !== this).forEach(r => {
                    r.isSelected = false;
                    r.internalRect.setAlpha(0)
                })
                this.internalRect.setAlpha(1)
                this.qcm.isRight = this.isRight
                this.qcm.validateBtn.setUnlocked()
            } else {
                this.isSelected = false;
                this.qcm.isRight = undefined
                this.internalRect.setAlpha(0)
                this.qcm.validateBtn.setLocked()
            }

        })
    }
    setCheckActif(){
        this.backRect.setInteractive({ useHandCursor: true })
    }
}
